var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettingsWithShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21832_89059)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2566 9.51072L19.3518 9.54533C21.9999 10.5104 21.9999 10.6228 22 10.8949V13.0146C22 13.2865 22 13.3886 19.3532 14.4365L19.2645 14.472L18.893 15.3724L18.9371 15.4682C20.1233 18.0162 20.0449 18.096 19.8557 18.2888L19.8555 18.2891L18.3503 19.7918C18.2876 19.8551 18.1784 19.8963 18.0865 19.8963C17.8595 19.8963 16.9836 19.5694 15.4839 18.9216L15.3972 18.8855L14.4856 19.2617L14.4495 19.3579C13.4818 21.9999 13.3713 22 13.105 22H10.984C10.7243 22 10.6172 21.9999 9.57371 19.3651L9.53812 19.2716L8.62264 18.8937L8.53378 18.9361C6.31482 19.9609 6.05955 19.9609 5.97561 19.9609C5.88285 19.9609 5.77409 19.9168 5.71125 19.8551L4.21209 18.358L4.2118 18.3577C4.0204 18.1633 3.94966 18.0915 5.07468 15.4858L5.11465 15.3936L4.74244 14.4919L4.64779 14.4578C2 13.4892 2 13.3761 2 13.1039V10.9829C2 10.7114 2 10.6098 4.64255 9.56736L4.73362 9.53142L5.10578 8.62707L5.06224 8.53244C3.87769 5.98097 3.95676 5.90058 4.14741 5.70863L5.65024 4.20919C5.7119 4.14719 5.82006 4.10473 5.91276 4.10473C6.14121 4.10473 7.01759 4.43228 8.51853 5.07821L8.60555 5.11514L9.51568 4.73642L9.55208 4.6403C10.519 2 10.6368 2 10.8953 2H13.0157C13.2752 2 13.382 2 14.4248 4.63572L14.4615 4.72869L15.3764 5.10477L15.4653 5.06402C17.6828 4.03882 17.9387 4.03882 18.0231 4.03882C18.1161 4.03882 18.2239 4.08254 18.2852 4.14471L19.7867 5.63984L19.7868 5.63996C19.9734 5.82879 20.0507 5.90705 18.9254 8.51234L18.8851 8.60537L19.2566 9.51072ZM8.56372 12.0005C8.56372 13.8964 10.1053 15.4399 12.0003 15.4399C13.8946 15.4399 15.4359 13.896 15.4359 12.0005C15.4359 10.1049 13.8945 8.56303 12.0003 8.56303C10.1054 8.56303 8.56372 10.1045 8.56372 12.0005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21832_89059",
    x: 1,
    y: 2,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21832_89059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21832_89059",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsWithShadow);
export default __webpack_public_path__ + "static/media/icon-settings-with-shadow.be655975b9b9a9a6cdab177beae257e3.svg";
export { ForwardRef as ReactComponent };